// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__YDrJP","info-container":"UserInfo_info-container__rbYqa","user-info":"UserInfo_user-info__TGtvq"};